namespace RioERP.Reports {
    export interface GstReportSummaryForm {
        ESourceType: Serenity.EnumEditor;
        OrderMonth: Serenity.EnumEditor;
        OrderYear: Serenity.EnumEditor;
        TotalTaxableAmount: Serenity.DecimalEditor;
        TotalTaxAmount: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class GstReportSummaryForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.GstReportSummary';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GstReportSummaryForm.init)  {
                GstReportSummaryForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(GstReportSummaryForm, [
                    'ESourceType', w0,
                    'OrderMonth', w0,
                    'OrderYear', w0,
                    'TotalTaxableAmount', w1,
                    'TotalTaxAmount', w1,
                    'CgstAmount', w1,
                    'SgstAmount', w1,
                    'IgstAmount', w1,
                    'TotalTax', w1
                ]);
            }
        }
    }
}
